import React from "react";

const TextSection = () => {
  return (
    <div className="custom__container text__section">
      <h3>Privacy Policy</h3>
      <h6>Introduction</h6>
      <br />
      <p>
        Welcome to FlexGrade, LLC’s (“<span>FlexGrade</span>”) privacy policy.
      </p>
      <br />
      <p>
        FlexGrade respects your privacy and is committed to protecting your
        personal data. This privacy policy will inform you as to how we look
        after your personal data (including when you simply visit our website
        regardless of where you visit it from) and tell you about your privacy
        rights and how the law protects you.
      </p>
      <br />
      <p>
        This is the Privacy Policy (“Policy”) for the websites operated by or on
        behalf of FlexGrade (“we” or “us”) and hosted at pages on the following
        domain: <a href="https://flexgrade.io">www.flexgrade.io</a> (“Site”).
        This Policy describes our general privacy policy and practices in
        relation to FlexGrade’s Site (navigating the Site, white paper
        downloads, event registrations, webinars, demo requests, pricing
        requests, or providing your personal information to us at our corporate
        events), including how we process personal information provided to us
        when you use our website, request our products or services, or otherwise
        contact us, such as via phone, email, mail, or chat. This policy does
        not cover information we process as a processor (e.g. personal
        information of customers).
      </p>
      <h6>General Information</h6>
      <br />
      <p>
        <span>Who is the Controller?</span>
      </p>
      <br />
      <p>
        The controller for the Site is FlexGrade, LLC (“FlexGrade”), and its
        data protection officer can be reached at{" "}
        <a href="mailto:legal@flexgrade.io">legal@flexgrade.io</a>.
      </p>
      <br />
      <p>
        <span>What “Personal Data” does FlexGrade collect?</span>
      </p>
      <br />
      <p>
        When using the Site, we may collect and process the following
        information about you:
      </p>
      <br />
      <p>
        <span>Information provided directly by you</span>
      </p>
      <br />
      <ul>
        <li>
          Direct Identifiers and Contact Information (such as your name, company
          name, email address, postal address, state/province, country, and
          telephone number) that you provide by completing forms on the Site or
          social media channels we operate, including information about you if
          you register as a user of the Site, such as profile photographs,
          images or video content, information about you that you upload or
          submit to the Site, or information you provide to us when requesting
          information or material from us;{" "}
        </li>
        <li>
          Information and other details of any transactions made by you through
          the Site including financial and billing information, account numbers,
          billing name and address, birth year, credit card number (“Billing
          Information”) provided by you when making transactions through the
          Site;{" "}
        </li>
        <li>
          Internet Activity Information: We may collect your IP address, browser
          information, device information, your location, and which pages you
          visit on our website. When you visit our website, we automatically
          collect this information through “cookies” or related technologies
          like pixels. Information contained in communications you send to us,
          for example to report a problem or to submit queries, concerns or
          comments regarding the Site (or its content) or the services (for more
          information on this please visit our Cookie Policy);{" "}
        </li>
        <li>
          Other additional information that you provide to us when attending our
          corporate webinars, meetings, conferences, or other outreach events.{" "}
        </li>
      </ul>

      <p>
        <span>Information about you collected from third parties</span>
      </p>
      <br />
      <p>
        We may also process your personal information that we have validly
        obtained from third parties.
      </p>
      <br />
      <p>
        <span>Why does FlexGrade need your Personal Data?</span>
      </p>
      <br />
      <p>
        We will collect and use your information as described in this Policy and
        as permitted by applicable laws, including in circumstances where it is
        necessary: (i) to provide or fulfill services requested or consented to;
        (ii) for the performance of a contract to which you are a party or in
        order to take steps at your request prior to entering into such a
        contract; (iii) for compliance with a legal obligation to which we are a
        subject; or (iv) to pursue our legitimate interests.
      </p>
      <br />
      <p>
        <span>
          For example, we may collect and use your information for the following
          purposes:
        </span>
      </p>
      <br />
      <ul>
        <li>
          {" "}
          To perform the services you requested or consented to. For example, if
          you fill out a “Contact Me” web form, we will use the information
          provided to contact you about your interest in the services. This data
          processing is necessary to provide or fulfil a service requested by or
          for you.
        </li>
        <li>
          {" "}
          We also utilize social media across various channels to stay connected
          and engage with you. In addition, we analyze how our company page is
          used on social media so that we can design and optimize it in line
          with requirements based on the insights gained.
        </li>
        <li>
          {" "}
          To plan and host events. For example, corporate events, host online
          forums and social networks in which event attendees may participate,
          and populate online profiles in relation to these events,{" "}
        </li>
        <li>
          {" "}
          The data processing is necessary to provide or fulfil a service
          requested by or for you.
        </li>
        <li>
          {" "}
          For marketing purposes. For example, we may use your information to
          further discuss your interest in the services and to send you
          information regarding FlexGrade and our group companies promotions,
          events, products, or services. We will only send you marketing
          communications and updates about our products, services, and events
          with your consent, where required by law or otherwise in our
          legitimate interests provided these interests do not override your
          right to object to such communications. As further described below,
          you can withdraw your consent at any time.
        </li>
        <li>
          {" "}
          In order to keep you up-to-date/request feedback. Within an existing
          business relationship between you and us, we may inform you, where
          permitted in accordance with local laws, about its products or
          services (including webinars, seminars or events) which are similar or
          relate to such products and services you have already purchased or
          used from us. Furthermore, where you have attended a webinar, seminar
          or event of FlexGrade or purchased products or services from us, we
          may contact you for feedback regarding the improvement of the relevant
          webinar, seminar, event, product, or service. You can object to
          further marketing at any time by checking and updating your contact
          details within your account, and/or selecting the “unsubscribe” link
          located on the bottom of FlexGrade’s marketing emails. Additionally,
          you may send a request to{" "}
          <a href="mailto:legal@flexgrade.io">legal@flexgrade.io</a>. As
          described further below, you have the right to contact us at any time
          to object to the further processing of your information for the
          purposes of direct marketing to you, including any profiling related
          to such marketing.
        </li>
        <li>
          {" "}
          For operating and improving FlexGrade’s Site and your customer
          experience. For example, with your consent we may collect and analyze
          data on your use of our website and process it for the purpose of
          improving our online customer experience. Data collected could include
          data about your device, such as unique device identifiers, information
          about your mobile phone or other mobile device(s), browser types,
          browser language, operating system, and the state or country from
          which you accessed the Site. Data collected could also include
          information related to the ways in which you interact with the Site,
          such as referring and exit pages and URLs, platform type, the number
          of clicks and domain names. This data allows us to understand our
          customers, their interaction with our website and improve our website
          to better serve our customers. We may use third-party analytics
          providers and technologies, including cookies and similar tools, to
          assist in collecting and analyzing this information. Please see our
          Cookie Policy for more details. Data processing for analytical,
          operational improvement, and/or customer benchmarking purposes is a
          legitimate business interest.
        </li>
        <li>
          {" "}
          For customizing the Site with location-based information, advertising,
          and features. For example, with your consent, we may collect
          advertising cookies. As another example, if you enable
          location-tracking on your mobile device and it shows you are close to
          a FlexGrade corporate event, we may reach out to you and let you know
          you should visit our nearby If you access the Site through a mobile
          device and you do not want your device to provide us with
          location-tracking information, you can disable the GPS or other
          location-tracking functions on your device, provided your device
          allows you to do this. This data processing is necessary to provide or
          fulfil a service requested by or for you, and can be disabled by you.
        </li>
        <li>
          {" "}
          Protection of FlexGrade and For example, we may disclose your
          information to: (i) comply with legal obligations; (ii) enforce any
          agreements that you entered into with us; (iii) respond to claims that
          any content violates the rights of third parties; (iv) respond to your
          requests for customer service; and/or (v) for security (e.g. fraud
          prevention and the prevention of unauthorized access). We may also
          disclose information to law enforcement agencies in emergency
          circumstances, where the disclosure of such information is consistent
          with the types of emergency disclosures permitted or required by law.
          This is data processing for compliance with a legal obligation.
        </li>
        <li>
          {" "}
          Business Transfers. For example, we reserve the right to disclose and
          transfer all of your information, to a successor (or potential
          successor) company in connection with a merger, acquisition, or sale
          of all, or components, of our business, or in connection with due
          diligence associated with any such transaction. Data processing for
          this purpose is a legitimate business interest.
        </li>
      </ul>
      <br />
      <p>
        <span>
          From What Types of Third Parties does FlexGrade obtain Personal Data?
        </span>
      </p>
      <br />
      <p>
        In most cases where Personal Data is needed, FlexGrade collects Personal
        Data directly from you. FlexGrade might also obtain personal data from
        third parties, if the applicable national law allows FlexGrade to do so.
        FlexGrade will treat this Personal Data according to this Privacy
        Statement, plus any additional restrictions imposed by the third party
        that provided FlexGrade with it or the applicable national law. These
        third-party sources include:
      </p>
      <br />
      <ul>
        <li>
          {" "}
          From third parties we work closely with (including, for example,
          business partners, sub- contractors in technical, payment and delivery
          services, advertising networks, analytics providers, and search
          information providers).
        </li>
        <li>
          {" "}
          From government authorities (e.g. law enforcement authorities for
          investigations)
        </li>
        <li>
          {" "}
          Other third parties, such as providers of publicly accessible sources
          (e.g. public websites, media, social media profiles, registers,
          records or databases), counterparties including their service
          providers (e.g. in litigation), or other companies or individuals at
          your direction.
        </li>
      </ul>
      <br />
      <p>
        <span>How long will FlexGrade store my Personal Data?</span>
      </p>
      <br />
      <p>
        The period for which FlexGrade retains your Personal Data depends on the
        purpose for which it is used. If you have an account with FlexGrade,
        FlexGrade will retain your data for as long as your customer account is
        active, unless otherwise specified. FlexGrade will only store your
        Personal Data for as long as reasonably necessary to accomplish
        FlexGrade’s legitimate business purposes, such as:
      </p>
      <br />
      <ul>
        <li> for the performance of services between you and FlexGrade;</li>
        <li> to make the Site available to you;</li>
        <li>
          {" "}
          for FlexGrade to comply with its statutory or regulatory obligations
          resulting from applicable export laws or other laws/regulations that
          oblige FlexGrade to retain personal data;
        </li>
        <li> to allow you to participate in our corporate events;</li>
        <li>
          {" "}
          to the conclusion of activities described in this Privacy Statement as
          being based upon legitimate business interest or until you object
          against such use;
        </li>
        <li>
          {" "}
          to the conclusion of activities described in this Privacy Statement as
          being based upon consent or until you revoke your consent;
        </li>
        <li> to fulfill the purposes outlined in this Privacy</li>
      </ul>
      <br />
      <p>
        FlexGrade will also retain your Personal Data for additional periods if
        it is required by mandatory law to do so, or where your Personal Data is
        required for FlexGrade to assert or defend against legal claims. In such
        cases, FlexGrade will retain your Personal Data until the end of the
        relevant retention period or until the claims in question have been
        settled. In some circumstances, we may anonymize your Personal Data so
        that it can no longer be associated with you, in which case it is no
        longer Personal Data.
      </p>
      <br />
      <p>
        <span>
          Who are the recipients of your Personal Data and where will it be
          processed?
        </span>
      </p>
      <br />
      <p>
        Your Personal Data will be passed on to the following categories of
        third parties to process your Personal Data:
      </p>
      <br />
      <ul>
        <li> Companies within the FlexGrade and its subsidiaries;</li>
        <li>
          {" "}
          Third-party service providers, including those providing consulting
          services and additional related services;
        </li>
        <li>
          {" "}
          Other service providers for the provision of the website or newsletter
          dispatch;
        </li>
        <li>
          {" "}
          State agencies and bodies, or regulatory authorities, based on entry
          requirements or police activities and investigations;
        </li>
        <li>
          {" "}
          Our agents, affiliates or contractors who assist us in providing the
          services we offer through our Site. The assistance provided by our
          agents, partners or contractors may be related to our marketing
          activities such as: updating marketing lists, data analytics,
          advertising, market research, participation in a contest or
          sweepstakes, and receiving and sending communications; Transactional
          assistance may also be provided by our agents, partners or
          contractors, including: processing transactions, fulfilling requests
          for information, billing, sales execution, and fulfilment of orders;
          Other support services provided may include: data storage, transfer,
          analysis and processing, legal services, providing IT, and in other
          tasks as requested, from time to time.
        </li>
        <li>
          {" "}
          Our agents, partners and contractors will only use your information to
          the extent necessary to perform their functions under this Policy and
          are subject to contractual restrictions prohibiting them from using
          your information for any other purpose.
        </li>
        <li>
          {" "}
          Professional advisors, including lawyers, bankers, auditors, and
          insurers.
        </li>
      </ul>

      <br />
      <p>
        We share your information with the above categories of third parties for
        the following purposes:
      </p>
      <br />
      <ul>
        <li>
          {" "}
          To protect FlexGrade and others: We may disclose any of your
          information to:(i) comply with legal process; (ii) enforce any
          agreements that you entered into with us; (iii) respond to claims that
          any content violates the rights of third parties; (iv) respond to your
          requests for customer service; and/or (v) the extent necessary for the
          purposes of the legitimate interests pursued by us or by the third
          party or parties to whom the data are disclosed, except where such
          interests are overridden by the interests for fundamental rights and
          freedoms of the data subjects.
        </li>
        <li>
          {" "}
          We may also disclose personal information in response to lawful
          requests by public authorities, including to meet national security or
          law enforcement requirements.
        </li>
      </ul>
      <br />
      <p>
        <span>International Data Transfers</span>
      </p>
      <br />
      <p>
        As part of FlexGrade's effort to provide a global service, FlexGrade has
        affiliates and third-party service providers outside of the European
        Economic Area (the “EEA”) or from a region with a legal restriction on
        international data transfers and will transfer your Personal Data to
        countries outside of the EEA. If these transfers are to a country for
        which the EU Commission has not issued an adequacy decision, FlexGrade
        usually uses the EU standard contractual clauses to contractually
        require that your Personal Data receives a level of data protection
        consistent with the EEA. In the absence of standard contractual clauses,
        we particularly rely on the following derogations: (i) you have given
        your explicit consent; (ii) it is necessary for the conclusion or
        performance of a contract with you or in your interests (iii) it is
        necessary for important reasons of public interest (iv) it is necessary
        to establish, exercise, or defend legal claims, or (v) it is necessary
        for the purposes of our compelling legitimate interests.
      </p>
      <h6>Processing Based On A Statutory Permission</h6>
      <br />
      <p>
        <span>
          Why does FlexGrade need to use my Personal Data and on what legal
          basis is FlexGrade using it?
        </span>
      </p>
      <br />
      <p>
        <span>Consent</span>
      </p>
      <br />
      <p>
        In specific cases we process your personal data only if you have given
        your consent, Art. 6(1), (a) GDPR. The withdrawal of consent shall not
        affect the lawfulness of processing based on consent before its
        withdrawal. For example, personalized Newsletter. If you opt-in to
        receive marketing communications such as newsletters from FlexGrade,
        FlexGrade will collect and store details of how you interact with the
        newsletters to help create, develop, operate, deliver and improve our
        newsletter communications with you. This information is aggregated and
        used to help FlexGrade provide more useful information and to understand
        what is of most interest.
      </p>
      <br />
      <p>
        <span>Processing to fulfill contractual obligation</span>
      </p>

      <br />
      <p>
        FlexGrade may require your Personal Data to deliver goods or services
        you order under a contract FlexGrade has with you, to establish a
        contract for goods or services between you and FlexGrade, and to send
        you invoices for ordered goods or services.
      </p>
      <br />
      <p>
        Additionally, FlexGrade may require your Personal Data to provide you,
        at your request, with access to FlexGrade events or FlexGrade materials
        such as whitepapers. FlexGrade processes Personal Data to fulfill
        contractual obligations pursuant to Article 6(1), 1(b) GDPR, or the
        equivalent article under other national laws, when applicable.
      </p>
      <br />
      <p>
        <span>Processing to ensure compliance</span>
      </p>
      <br />
      <p>
        FlexGrade and its products, technologies, and services are subject to
        the export laws of various countries including, without limitation,
        those of the European Union and its member states, and of the United
        States of America. You acknowledge that, pursuant to the applicable
        export laws, trade sanctions, and embargoes issued by these countries,
        FlexGrade is required to take measures to prevent entities,
        organizations, and parties listed on government-issued sanctioned-party
        lists from accessing certain products, technologies, and services
        through FlexGrade’s websites or other delivery channels controlled by
        FlexGrade. This could include (i) automated checks of any user
        registration data as set out herein and other information a user
        provides about his or her identity against applicable sanctioned-party
        lists; (ii) regular repetition of such checks whenever a
        sanctioned-party list is updated or when a user updates his or her
        information; (iii) blocking of access to FlexGrade’s services and
        systems in case of a potential match; and (iv) contacting a user to
        confirm his or her identity in case of a potential match. Any such use
        of your Personal Data is based on the permission to process Personal
        Data in order to comply with statutory obligations (Article 6 (1), (c)
        GDPR or the equivalent articles under other national laws, when
        applicable) and FlexGrade’s legitimate interest (Article 6 (1), (f) GDPR
        or the equivalent articles under other national laws, when applicable).
      </p>
      <br />
      <p>
        <span>Processing based on FlexGrade’s legitimate interest</span>
      </p>
      <br />
      <p>
        FlexGrade can use your Personal Data based on its legitimate interest
        (Article 6 (1), (f) GDPR or the equivalent articles under other national
        laws, when applicable) as follows:
      </p>
      <br />
      <ul>
        <li>
          {" "}
          <span>Fraud and Legal Claims.</span> If required, FlexGrade will use
          your Personal Data for the purposes of preventing or prosecuting
          criminal activities such as fraud and to assert or defend against
          legal claims.
        </li>
        <li>
          {" "}
          <span>Questionnaires and Surveys.</span> FlexGrade could invite you to
          participate in questionnaires and surveys. These questionnaires and
          surveys will be generally designed in a way that they can be answered
          without any data that can be used to identify you. If you nonetheless
          enter such data in a questionnaire or survey, FlexGrade will use this
          personal data to improve its products and services.
        </li>
        <li>
          {" "}
          <span>Contract Performance.</span> If you purchase or intend to
          purchase goods or services from FlexGrade on behalf of a corporate
          customer or otherwise be the nominated contact person for the business
          relationship between a corporate customer (a “Customer Contact”) and
          FlexGrade, FlexGrade will use your Personal Data for this purpose.
          This includes, for the avoidance of doubt, such steps which are
          required for establishing the relevant business relationship. In case
          that an existing Customer Contact informs FlexGrade that you are his
          replacement, FlexGrade will, from the point in time of such
          notification, consider you to be the relevant Customer Contact for the
          respective customer until you object as further set out below.
        </li>
        <li>
          {" "}
          <span>Creation of anonymized data sets.</span> FlexGrade will
          anonymize Personal Data provided under this Privacy Statement to
          create anonymized data sets, which will then be used to improve its
          and its affiliates’ products and services.
        </li>
        <li>
          {" "}
          <span>Recordings for quality improvement purposes.</span> In case of
          telephone calls or chat sessions, FlexGrade will record such calls
          (after informing you accordingly during that call and before the
          recording starts) or chat sessions in order to improve the quality of
          FlexGrade’s services.
        </li>
        <li>
          {" "}
          <span>To keep you up-to-date or request.</span> Within an existing
          business relationship between you and FlexGrade, FlexGrade might
          inform you, where permitted in accordance with local laws, about its
          products or services (including webinars, seminars or events) which
          are similar or relate to such products and services you have already
          purchased or used from FlexGrade. Furthermore, where you have attended
          a webinar, seminar or event of FlexGrade or purchased products or
          services from FlexGrade, FlexGrade might contact you for feedback
          regarding the improvement of the relevant webinar, seminar, event,
          product or service.
        </li>
        <li>
          {" "}
          If we rely on your consent to process your Personal Data, then you can
          withdraw your consent at any time. Withdrawing your consent will not
          affect the lawfulness of any processing we conducted prior to your
          withdrawal, nor will it affect processing of your Personal Data
          conducted in reliance on lawful processing grounds other than consent.
        </li>
      </ul>
      <h6>Cookies and Similar Tools</h6>
      <br />
      <p>
        Information gathered by cookies or similar technologies, and any use of
        such information, is further described in FlexGrade’s Cookie Policy. You
        can exercise your cookie preferences as outlined in FlexGrade’s Cookie
        Statement by visiting the Cookie Preferences tool in the bottom footer
        of the homepage.
      </p>
      <h6>Children</h6>
      <br />
      <p>
        FlexGrade does not knowingly collect the Personal Data of children under
        the age of 16. If you are a parent or guardian and believe FlexGrade
        collected information about a child, please contact FlexGrade as
        described in this Privacy FlexGrade will take steps to delete the
        information as soon as possible. Given that FlexGrade is not directed to
        users under 16 years of age and in accordance with the disclosure
        requirements of the CCPA, FlexGrade does not sell the Personal Data of
        any minors under 16 years of age.
      </p>
      <h6>Consumer Rights</h6>
      <br />
      <p>
        Depending on your jurisdiction, you may be entitled to the rights
        described below, subject to certain conditions and limitations. We may
        choose to offer these rights, even if we are not required to under
        applicable privacy law.
      </p>
      <br />
      <ul>
        <li>
          {" "}
          <span>Right to access/know.</span> You have the right to know and
          request information about the categories and specific pieces of
          personal information we have collected about you (in some
          jurisdictions limited to the last 12 months), as well as the
          categories of sources from which such information is collected, the
          purpose for collecting such information, and the categories of third
          parties, or specific third parties, depending on your jurisdiction,
          with whom we share such information. You also have the right to know
          if we have sold or disclosed your personal information.
        </li>
        <li>
          {" "}
          <span>Right to correct.</span> You have the right to request
          correction of any inaccurate information we hold about you. We may not
          be able to accommodate your request if we believe it would violate any
          law, any legal requirements, or cause the information to be incorrect.
          Information solely retained for data backup purposes is generally
          excluded.
        </li>
        <li>
          {" "}
          <span>Right to delete.</span> You have the right to request the
          deletion of your personal information, subject to certain exceptions.
        </li>
        <li>
          {" "}
          <span>
            Right to limit use and disclosure of or opt-in to processing of
            sensitive personal information.
          </span>{" "}
          Depending on your jurisdiction, you may have the right to limit our
          processing and use of your sensitive personal data. You may also have
          the right to opt-in to the processing of your sensitive information.
          The categories of sensitive personal information (if any) we collect
          are described above.
        </li>
        <li>
          {" "}
          <span>
            Right to opt-out of the sale or sharing of personal information.
          </span>{" "}
          We do not sell or share your personal information. Depending on your
          jurisdiction, you may have the right to opt-out of the sharing of your
          personal information for cross-context behavioral advertising and
          targeted advertising.
        </li>
        <li>
          {" "}
          <span>Right to know and question profiling decisions.</span> Depending
          on your jurisdiction, and whether your personal data is profiled in
          furtherance of decisions that produce legal or similarly significant
          effects concerning you, you may have the right to question the result
          of said profiling, the right to be informed of the reason that the
          profiling resulted in the decision, and, if feasible, the right to be
          informed of what actions you might have taken to secure a different
          decision and that you might take to secure a different decision in the
          future. You also have the right to review the personal data used in
          the profiling decision. We do not engage in profiling, therefore we do
          not offer this right.
        </li>
        <li>
          {" "}
          <span>
            Right to correct data and reevaluate decisions related to profiling
            decisions.
          </span>{" "}
          Depending on your jurisdiction, if a profiling decision was based upon
          inaccurate personal information, taking into account the nature of the
          personal data and purpose of processing, you may have the right to
          have the data corrected and the profiling decision reevaluated based
          upon the corrected data. We do not engage in profiling, therefore we
          do not offer this right.
        </li>
        <li>
          {" "}
          <span>Right to portable data.</span> You have the right to obtain
          personal information about you in a portable and, to the extent
          technically feasible, readily usable format that allows you to
          transmit the information to another entity without hindrance.
        </li>
        <li>
          {" "}
          <span>Right to Withdraw Consent and Object.</span> You can withdraw
          your consent at any time and object to FlexGrade’s use of your
          Personal Data as set forth in this section by sending an email to{" "}
          <a href="mailto:legal@flexgrade.io">legal@flexgrade.io</a>. In case of
          objection, FlexGrade will carefully review your objection and cease
          further use of the relevant information, subject to FlexGrade’s
          compelling legitimate grounds for continued use of the information,
          which override your interest in objecting, or if FlexGrade requires
          the information for the establishment, exercise or defense of legal
          claims.{" "}
          <span>
            Where personal data is processed for direct marketing purposes, then
            you have the right to object at any time.
          </span>
        </li>
        <li>
          {" "}
          <span>
            Right to lodge a complaint with a supervisory authority.
          </span>{" "}
          If you have any concerns about how we process your personal data, we
          encourage you to let us know so we can try to resolve your concerns.
          Irrespective of this, if you think we have not complied with data
          protection laws, you have the right to lodge a complaint with the
          competent supervisory authority under Art. 77 GDPR.
        </li>
        <li>
          {" "}
          <span>Right to non-discrimination.</span> You have the right to not be
          discriminated against for exercising any of the above-listed rights.
        </li>
      </ul>
      <br />

      <p>
        In accordance with the disclosure requirements under the California
        Consumer Privacy Act (“CCPA”) and California Privacy Rights Act
        (“CPRA”), FlexGrade does not and will not sell your Personal Data.
      </p>
      <br />
      <p>
        FlexGrade will require a more stringent verification process for
        deletion requests, or for Personal Data that is considered sensitive or
        valuable, to minimize the harm that might be posed to you by
        unauthorized access or deletion of your Personal Data. If FlexGrade must
        request additional information from you outside of information that is
        already maintained by FlexGrade, FlexGrade will only use it to verify
        your identity so you can exercise your data protection rights, or for
        security and fraud-prevention purposes. We cannot respond to your
        request or provide you with personal information if we cannot verify
        your identity or authority to make the request and confirm the personal
        information related to you. Making a verifiable consumer request does
        not require you to create an account with us. We will use the personal
        information you provide to us when submitting a consumer request only to
        verify the requestor’s identity or authority to make the request.
      </p>
      <br />
      <p>
        Data solely retained for data backup purposes is principally excluded
        from these rights until it is restored to an active system or next
        accessed or used for a sale, disclosure, or commercial purpose. These
        rights also do not apply to pseudonymous data if the information
        necessary to identify the individual is kept separately and is subject
        to controls that prevent access to the information. Pseudonymous data is
        personal data that can no longer be attributed to a specific individual
        without the use of additional information, if the additional information
        is kept separately and is subject to measures to ensure that personal
        data is not attributed to the specific individual.
      </p>
      <br />
      <p>
        In addition to contacting FlexGrade at{" "}
        <a href="mailto:legal@flexgrade.io">legal@flexgrade.io</a> or submitting
        a request via our webform, you may also exercise your rights as follows.
        You can designate an authorized agent to submit requests to exercise
        your data protection rights to FlexGrade. If you are submitting a
        request through an authorized agent, the authorized agent must provide
        us with your signed written permission stating that the agent is
        authorized to make the request on your behalf.
      </p>
      <p>
        Alternatively, your authorized agent may provide evidence of having
        power of attorney or acting as a conservator for you. We may also
        request that any authorized agents verify their identity and may reach
        out to you directly to confirm that you have provided the agent with
        your permission to submit the request on your behalf.
      </p>
      <br />
      <p>
        Depending on your jurisdiction, we have between 30 and 90 days to
        respond to your request.
      </p>
      <p>
        There may be circumstances where we will not be able to honor your
        request, in which case, we will notify you. For example, if you request
        deletion, we may need to retain certain personal information to comply
        with our legal obligations or other permitted purposes. Depending on
        your jurisdiction, you may have the right to appeal this decision or to
        contact your Attorney General if you have concerns about the results of
        the appeal.
      </p>
      <br />
      <p>
        Please note that depending on your jurisdiction, we may only be
        obligated to respond, free of cost, to personal information requests
        from the same consumer up to two times in a 12-month period. Depending
        on your jurisdiction, after you have exceeded the applicable number of
        requests, we may have the right to charge a reasonable fee for
        fulfilling the request. In addition, under the applicable state privacy
        law, and for the protection of your personal information, we may be
        limited in what personal information we can disclose.
      </p>
      <p>
        Depending on your jurisdiction, we may maintain your rights requests for
        at least 2 years. This information will not be used for any other
        purpose except to review compliance processes; it will not be shared
        except as necessary to comply with a legal obligation.
      </p>
      <br />
      <p>
        <span>Do Not Track Signals</span>
      </p>
      <br />
      <p>
        We partner with third parties to display advertising on our websites or
        to manage our advertising on other websites. Our third-party partners
        use cookies, web beacons, LSOs, tags, scripts, and similar technologies
        to gather information about you over time and across different websites
        or applications to help predict your preferences and show you ads on
        sites across the Internet. If you wish to manage your cookie preferences
        directly with us, please use our Cookie Preference tool in the bottom
        footer of the homepage or make a request using one of the methods
        outlined in the Cookies Section of this policy.
      </p>
      <br />
      <p>
        We recognize your use of a universal opt-out mechanism for the purpose
        of targeted advertising or sale of your personal data. If there is a
        conflict between the opt-out request received via a universal opt-out
        mechanism and your existing privacy setting, we will comply with your
        opt-out preference and notify you of the conflict. The notification will
        provide you with the option to confirm either the privacy setting or
        participation in the program.
      </p>
      <br />
      <p>
        <span>Third Party Content and Links</span>
      </p>
      <br />
      <p>
        Our website may include links to third-party websites, plug-ins, and
        applications.
      </p>
      <p>
        Clicking on those links or enabling those connections may allow third
        parties to collect or share data about you. We do not control
        third-party websites and are not responsible for their privacy
        statements. If you submit personal information to any third-party
        websites or service providers, your information is governed by their
        privacy policies.
      </p>
      <br />
      <p>
        When you leave our website, we encourage you to read the privacy policy
        on every website you visit.
      </p>
      <br />
      <p>
        <span>Changes to the Privacy Policy</span>
      </p>
      <br />
      <p>
        From time to time, we may update this privacy policy. We will post any
        revised version of this privacy policy on our website. Any changes will
        be effective on the effective date stated in the revised policy. This
        privacy policy was last updated as of the effective date listed above.
        We will not use previously collected personal information for a new
        purpose without providing notice and/or obtaining your consent, as
        appropriate. We may make minor changes to this policy without providing
        advanced notice and/or obtaining your consent. We encourage you to
        periodically review this page for the latest information on our privacy
        practices.
      </p>
      <h6>Data Security </h6>
      <br />
      <p>
        We have put in place appropriate security measures to prevent your
        personal data from being accidentally lost, used, or accessed in an
        unauthorized way, altered, or disclosed. In addition, we limit access to
        your personal data to those employees, agents, contractors and other
        third parties who have a business need to know. They will only process
        your personal data on our instructions, and they are subject to a duty
        of confidentiality. However, the Internet is an open system, and we
        cannot guarantee that unauthorized third parties will never be able to
        defeat those measures or use your personal information for improper
        purposes.
      </p>
      <br />
      <p>
        We have put in place procedures to deal with any suspected personal data
        breach and will notify you and any applicable regulator of a breach
        where we are legally required to do so.
      </p>
      <br />
      <p>
        If you communicate with us by email, you should note that the secrecy of
        Internet email is uncertain. By sending sensitive or confidential email
        messages or information which are not encrypted you accept the risk of
        such uncertainty and possible lack of confidentiality over the Internet.
      </p>

      <h6>Contact us</h6>
      <br />
      <p>Have additional privacy questions or need further info?</p>
      <br />
      <p>
        If you have any questions, comments, or concerns regarding this Policy
        or FlexGrade’s privacy practices, you may contact us at ATTN: Privacy
        Policy, c/o FlexGrade,{" "}
        <a href="mailto:legal@flexgrade.io">legal@flexgrade.io</a>.
      </p>
    </div>
  );
};

export default TextSection;
